"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsDataElementOptionType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsDataElementOptionType_Factory = /** @class */ (function () {
    function EFormsDataElementOptionType_Factory() {
    }
    EFormsDataElementOptionType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    EFormsDataElementOptionType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return EFormsDataElementOptionType_Factory;
}());
exports.EFormsDataElementOptionType_Factory = EFormsDataElementOptionType_Factory;
